import { useEffect } from 'react';

import type { RenderPageProps } from '@react-pdf-viewer/core';

// Removes pdf footer display
export const CustomPageLayer = ({
  renderPageProps,
}: {
  renderPageProps: RenderPageProps;
}) => {
  useEffect(() => {
    // Mark the page rendered completely when the canvas layer is rendered completely
    // So the next page will be rendered
    if (renderPageProps.canvasLayerRendered) {
      renderPageProps.markRendered(renderPageProps.pageIndex);
    }
    /* eslint-disable-next-line react-hooks/exhaustive-deps -- React Hook React.useEffect has a missing dependency: 'renderPageProps'. Either include it or remove the dependency array. */
  }, [renderPageProps.canvasLayerRendered]);

  return (
    <>
      {renderPageProps.canvasLayer.children}
      {renderPageProps.annotationLayer.children}
    </>
  );
};
